import type { TierEnum } from '../enums/TierEnum'
import { JsonObject, JsonProperty } from 'json2typescript'
import ProductEnumConverter from '@/converters/ProductEnumConverter'
import SchemeTierEnumConverter from '@/converters/SchemeTierEnumConverter'
import ProductEnum from '../enums/ProductEnum'

@JsonObject('AggregatorQuoteReference')
export default class AggregatorQuoteReference {
  @JsonProperty('reference', String)
  reference: string

  @JsonProperty('premium', Number)
  premium: number

  @JsonProperty('product', ProductEnumConverter)
  product: ProductEnum

  @JsonProperty('schemeCode', String)
  schemeCode: string

  @JsonProperty('quoteReference', String)
  quoteReference: string

  @JsonProperty('schemeTier', SchemeTierEnumConverter)
  schemeTier: TierEnum | null = null

  @JsonProperty('coverTypeName', String)
  coverTypeName: string

  constructor(
    reference = '',
    premium = 0,
    product = ProductEnum.modernCar,
    schemeCode = '',
    quoteReference = '',
    schemeTier = null,
    coverTypeName = '',
  ) {
    this.reference = reference
    this.premium = premium
    this.product = product
    this.schemeCode = schemeCode
    this.quoteReference = quoteReference
    this.schemeTier = schemeTier
    this.coverTypeName = coverTypeName
  }
}
